import { render, staticRenderFns } from "./BranchesReact.vue?vue&type=template&id=f73548a4&"
import script from "./BranchesReact.vue?vue&type=script&lang=js&"
export * from "./BranchesReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports